import { FaCar, FaShip, FaTruck } from 'react-icons/fa';
import CtaButton from './CtaButton';
import './ServiceCards.css';

const services = [
  {
    icon: FaCar,
    title: 'Automotive GPS Update',
    desc: 'Refresh road networks, lane guidance, and points of interest for passenger vehicles and daily drivers.',
  },
  {
    icon: FaTruck,
    title: 'In-Dash Navigation Update',
    desc: 'Update factory navigation systems with improved routing, traffic-ready maps, and newer destination data.',
  },
  {
    icon: FaShip,
    title: 'Marine GPS Updates',
    desc: 'Keep nautical charts current with updated coastlines, hazards, marinas, and waterway corrections.',
  },
];

export default function ServiceCards() {
  return (
    <section className="section" id="services">
      <div className="container">
        <h2 className="section-title center">Map Update Services</h2>
        <p className="section-lead center">
          Whether you drive, haul, or sail — we help you find the right map package and update path for your device.
        </p>

        <div className="service-grid">
          {services.map(({ icon: Icon, title, desc }) => (
            <article key={title} className="service-card">
              <div className="service-icon" aria-hidden="true">
                <Icon />
              </div>
              <h3>{title}</h3>
              <p>{desc}</p>
            </article>
          ))}
        </div>

        <div className="service-cta-wrap">
          <CtaButton className="btn btn-primary">Request Map Update Help</CtaButton>
        </div>
      </div>
    </section>
  );
}
